<template>
  <div class="zhinengtouyan-layer">
    <caseheader></caseheader>
    <div class="znty-container">
      <div class="znty-left">
        <div class="znty-left-back pointer" @click="goBack">
          <img src="@/assets/imgs/case/image_308.png" alt="">
        </div>
        <!-- 进度条组件 -->
        <div class="znty-left-progress">
          <div class="znty-left-title">
            个人投资者智能投顾助手
          </div>
          <div class="progress-container">
            <div class="progress-item pointer" @click="nextStep('Step1')">
              <div class="progress-bar completed">
              </div>
            </div>
            <div class="progress-item pointer" @click="nextStep('Step2')">
              <div class="progress-bar active">
              </div>
            </div>
            <div class="progress-item not-allowed">
              <div class="progress-bar notactive">
              </div>
            </div>
            <div class="progress-item not-allowed">
              <div class="progress-bar notactive">
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 内容区域 -->
      <div class="znty-content">
        <component :is="currentStep" @nextStep="nextStep" />
      </div>
    </div>
  </div>
</template>

<script>
import Caseheader from '@/components/layout/caseheader.vue'
import Step1 from '@/views/case/zhinengtouyan/step1.vue'
import Step2 from '@/views/case/zhinengtouyan/step2.vue'

export default {
  name: 'zhinengtouyan-layer',
  components: {
    Caseheader,
    Step1,
    Step2,
  },
  props: {},
  data () {
    return {
      currentStep: 'Step1'
    }
  },
  computed: {},
  watch: {},
  created () { },
  mounted () { },
  methods: {
    goBack () {
      if (this.currentStep === 'Step1') {
        // 不做处理
        // this.$router.go(-1)
      } else {
        this.nextStep('Step1')
      }
    },
    nextStep (step) {
      this.currentStep = step
    }
  }
}
</script>

<style scoped lang="less">
.zhinengtouyan-layer {
  height: 100%;

  .znty-container {
    padding: 20px;
    display: flex;
    gap: 20px;
    height: calc(100% - 100px);
    width: calc(100% - 40px);

    .znty-left {
      border-radius: 8px;
      padding: 0 20px 20px 20px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
      display: flex;
      flex-direction: column;

      .znty-left-back {
        width: 54px;
        height: 54px;
        padding-bottom: 20px;

        img {
          width: 100%;
          height: 100%;
          display: block;
        }
      }

      .znty-left-progress {
        display: flex;

        .znty-left-title {
          font-size: 18px;
          color: #d9d9d9;
          //文字竖排
          writing-mode: vertical-rl;
          letter-spacing: 5px;
          padding-right: 20px;
        }

        .progress-container {
          display: flex;
          flex-direction: column;
          gap: 16px;
        }

        .progress-item {
          position: relative;
        }

        .pointer {
          cursor: pointer;
        }

        .not-allowed {
          cursor: not-allowed;
        }

        .progress-bar {
          height: 80px;
          border-radius: 6px;
          display: flex;
          align-items: center;
          padding-left: 10px;
          transition: all 0.3s ease;
          color: white;
          font-weight: 500;
          position: relative;
          overflow: hidden;
        }

        .progress-bar.completed {
          background-color: #1890ff;
          /* 蓝色 - 已完成步骤 */
        }

        .progress-bar.active {
          background-color: #52c41a;
          /* 绿色 - 当前步骤 */
          box-shadow: 0 2px 4px rgba(82, 196, 26, 0.3);
        }

        .progress-bar.notactive {
          background-color: #d9d9d9;
          color: #666;
        }

        .progress-text {
          position: relative;
          z-index: 1;
        }
      }
    }

    .znty-content {
      flex: 1;
      background: rgba(5, 5, 5, 0.68);
      border-radius: 25px;
      color: #fff;
      padding: 30px;
      height: calc(100% - 60px);
    }
  }

}
</style>
